export default __webpack_public_path__ + "static/media/kalahastiTemple3.0d44acea.png";